import { Reference } from '../reference.model';
import { BaseEditableProperties, Widget } from './widget.model';

export type WorkflowWidget = Widget & {
  widgetType: 'workflow';
  workflowId?: string;
  workflowTitle?: string;
  workflowVersion?: number;
  latestVersion?: number;
  isOutdated?: boolean;
} & {
  localChanges?: WorkflowWidgetLocalChanges;
};

export type WorkflowWidgetLocalChanges = BaseEditableProperties &
  Partial<{
    text: string;
    references: Reference[];
  }>;

export const createWorkflowWidget = (overrides: Partial<Omit<WorkflowWidget, 'widgetType'>>): WorkflowWidget => {
  return {
    widgetType: 'workflow',
    uniqueId: crypto.randomUUID(),
    references: [],
    attachments: [],
    links: [],
    workflowId: undefined,
    workflowVersion: undefined,
    workflowTitle: undefined,
    latestVersion: undefined,
    isOutdated: undefined,
    ...overrides,
  };
};
